import styled, { css } from 'styled-components';
import { media } from '../../../../theme/shared/breakpoints';
const BasePopupOverlay = styled.div `
  position: fixed;
  z-index: 1002;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(16, 17, 26, 0.5);

  ${({ isNewDesign }) => isNewDesign &&
    css `
      align-items: flex-end;
      background-color: rgba(245, 245, 245, 0.9);

      ${media.large} {
        align-items: center;
      }
    `}
`;
export default BasePopupOverlay;
//# sourceMappingURL=BasePopupOverlay.js.map